import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import ProductsByIds from './Products/ProductsByIds';
import Search from './Search';
import * as serviceWorker from './serviceWorker';
import { ApolloProvider } from '@apollo/client'
import {WooProvider} from './WooContext';
import {WooSimpleProvider} from './WooSimpleContext';
import client from './apolloClient';
import {WooSearchProvider} from "./WooSearchContext";

const targets = document.querySelectorAll('[data-woo-root]')||[];

if (targets.length) {
    targets.forEach(target => {
        ReactDOM.render(
            <React.StrictMode>
                <ApolloProvider client={client}>
                    {target.dataset.wooRoot === 'filters' &&
                    <WooProvider defaultCategoryId={target.dataset.product_catId||0} defaultSectorId={target.dataset.sectorId||0} defaultBrandId={target.dataset.pa_brandId||0} defaultPerPage={target.dataset.wrPerPage||12} defaultHireOrSale={target.dataset.hireOrSale||null} defaultPage={target.dataset.wrPage||0} acctCustomer={target.dataset.acctCustomer||0}>
                        <App />
                    </WooProvider>}
                    {target.dataset.wooRoot === 'productsById' &&
                    <WooSimpleProvider productIds={target.dataset.productIds||[]} acctCustomer={target.dataset.acctCustomer||0}>
                        <ProductsByIds carousel={!!target.dataset.glideEl} />
                    </WooSimpleProvider>}
                    {target.dataset.wooRoot === 'search' &&
                    <WooSearchProvider>
                        <Search/>
                    </WooSearchProvider>}
                </ApolloProvider>
            </React.StrictMode>,
            target
        );
        serviceWorker.unregister();
    });
}